export function FormReducer(state, { key, payload }) {
  if (!state.hasOwnProperty(key)) {
    state[key] = { value: '', error: null }
  }
  state[key].value = payload.value;
  state[key].error = payload.error;
  return state
}